import {useEffect, useRef, useState} from "react";
import {IconButton, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {ArrowUpward, Help} from "@mui/icons-material";
import VatSelector from "./VatSelector";
import HelpVat from "./HelpVat";
import StandardizedItemSelector from "./StandardizedItemSelector";
import useHelper from "../../../../../../use/useHelper";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import parameter from "../../../../../../enum/parameter";
import isNull from "../../../../../../mixin/isNull";
import Modal from "../../../../../../material/modal/Modal";
import ModalConfig from "../../../../../../material/modal/ModalConfig";
import UpdateQuotationItem from "./UpdateQuotationItem";
import QuotationItemOption from "./QuotationItemOption";

const DEFAULT_VAT = 10;

export default function ({orderId, onQuotationPayloadChange, onQuotationItemPayloadChange}) {
    const helper = useHelper();
    const eventDispatcher = useEventDispatcher();
    const [quotationItems, setQuotationItems] = useState([]);
    const [vat, setVat] = useState(DEFAULT_VAT);
    const [openVatHelp, setOpenVatHelp] = useState(false);
    const [updateItem, setUpdateItem] = useState(null);
    const vatSelectorRef = useRef();

    useEffect(() => {
        setTimeout(() => eventDispatcher.launcher("change-vat"), 100);
    }, []);

    useEffect(() => {
        onQuotationItemPayloadChange(quotationItems);
    }, [JSON.stringify(quotationItems)]);

    useEffect(() => {
        onQuotationPayloadChange({vat});
    }, [vat]);

    const toggleVatHelp = o => () => setOpenVatHelp(o);
    const handleVatChange = e => setVat(e.target.value);
    const handleAdd = item => setQuotationItems(prev => [...prev, item]);
    const handleDelete = index => () => setQuotationItems(prev => prev.filter((_, i) => i !== index));
    const handleUpdate = index => item => {
        setUpdateItem(null);
        const current = [...quotationItems];
        current[index] = item;
        setQuotationItems(current);

    };

    return (
        <>
            <Table size={"small"}>
                <TableHead>
                    <TableRow>
                        <TableCell>Item</TableCell>
                        <TableCell>Qté</TableCell>
                        <TableCell>HT (€)</TableCell>
                        <TableCell/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        quotationItems.map((item, i) => (
                            <TableRow key={i} data-test="insurance-quotation-item-row">
                                <TableCell width={"60%"}>
                                    <Typography fontSize={"small"}>{item.name}</Typography>
                                </TableCell>
                                <TableCell width={"15%"}>{item.quantity}</TableCell>
                                <TableCell width={"20%"}>
                                    {helper.priceFormatter(item.pricing / 100)}
                                </TableCell>
                                <TableCell width={"5%"}>
                                    <QuotationItemOption
                                        onDelete={handleDelete(i)}
                                        onUpdate={() => setUpdateItem(i)}
                                    />
                                </TableCell>
                            </TableRow>
                        ))
                    }
                    {
                        quotationItems.length === 0
                            ? (
                                <TableRow>
                                    <TableCell colSpan={4}>
                                        <Typography textAlign="center" variant="caption">
                                            Aucun item pour le moment
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )
                            : null
                    }
                    <TableRow>
                        <TableCell colSpan={2}>
                            <Box display="flex" alignItems="center" ref={vatSelectorRef}>
                                <div>
                                    <IconButton
                                        size="small"
                                        color={"warning"}
                                        onClick={toggleVatHelp(true)}
                                        data-test="insurance-button-help-vat"
                                    >
                                        <Help/>
                                    </IconButton>
                                </div>
                                <Typography fontSize={"small"} fontWeight={"bold"}>
                                    TVA
                                </Typography>
                            </Box>
                            <PopperWrapper
                                elementRef={vatSelectorRef}
                                placement={"bottom"}
                                content={"Changez la TVA en fonction de votre entreprise"}
                                triggeringEvent={"change-vat"}
                                autoCloseAfter={parameter.POPUP_TIME}
                                displayCloseButton={false}
                                contentColor={parameter.POPUP_COLOR}
                                icon={<ArrowUpward color={parameter.POPUP_COLOR}/>}
                            />
                        </TableCell>
                        <TableCell colSpan={2}>
                            <VatSelector onChange={handleVatChange}/>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Box mt={4}>
                <StandardizedItemSelector
                    orderId={orderId}
                    onSelect={handleAdd}
                    currentQuotationItems={quotationItems}
                />
            </Box>

            <HelpVat open={openVatHelp} onClose={toggleVatHelp(false)}/>

            {
                !isNull(updateItem)
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setOnClose(() => setUpdateItem(null))
                                    .setWidth("100%")
                                    .setHeight("80%")
                                    .setComponent(
                                        <UpdateQuotationItem
                                            quotationItem={quotationItems[updateItem]}
                                            onSubmit={handleUpdate(updateItem)}
                                        />
                                    )
                            }
                        />
                    )
                    : null
            }
        </>
    );
}
